// Z-Index Management Utility

// Z-Index Levels
export const Z_INDEX_LEVELS = {
  // Base levels
  DROPDOWN: 1000,
  STICKY: 1020,
  FIXED: 1030,
  MODAL_BACKDROP: 1040,
  MODAL: 1050,
  POPOVER: 1060,
  TOOLTIP: 1070,
  
  // High priority levels
  HIGH_MODAL: 9999,
  HIGH_POPOVER: 10000,
  
  // Maximum levels
  MAX_MODAL: 99999,
  MAX_POPOVER: 100000,
  
  // Gift system (highest priority)
  GIFT_MODAL: 999999,
  GIFT_CONTENT: 1000000
};

// Get next available z-index
export const getNextZIndex = (baseLevel = Z_INDEX_LEVELS.MODAL) => {
  return baseLevel + Math.floor(Math.random() * 100);
};

// Ensure element is on top
export const bringToFront = (element, level = Z_INDEX_LEVELS.MAX_MODAL) => {
  if (element && element.style) {
    element.style.zIndex = level.toString();
  }
};

// Reset z-index
export const resetZIndex = (element) => {
  if (element && element.style) {
    element.style.zIndex = '';
  }
};

// Check if element is visible
export const isElementVisible = (element) => {
  if (!element) return false;
  
  const rect = element.getBoundingClientRect();
  const style = window.getComputedStyle(element);
  
  return (
    rect.width > 0 &&
    rect.height > 0 &&
    style.display !== 'none' &&
    style.visibility !== 'hidden' &&
    style.opacity !== '0'
  );
};

// Find all modals and adjust z-index
export const adjustModalZIndex = () => {
  const modals = document.querySelectorAll('[data-modal="true"], .modal, .gift-modal-overlay');
  
  modals.forEach((modal, index) => {
    if (modal.classList.contains('gift-modal-overlay')) {
      modal.style.zIndex = Z_INDEX_LEVELS.GIFT_MODAL.toString();
    } else {
      modal.style.zIndex = (Z_INDEX_LEVELS.MAX_MODAL + index).toString();
    }
  });
};

// Auto-adjust z-index on page load
export const initZIndexManager = () => {
  // Adjust z-index on page load
  adjustModalZIndex();
  
  // Watch for new modals
  const observer = new MutationObserver(() => {
    adjustModalZIndex();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  return observer;
};






